import React from "react";
import { AlertOctagon, AlertTriangle, CheckCircle2, HelpCircle } from "lucide-react";

const MAP = {
  expired:       { label: "EXPIRED",        color: "text-white bg-status-expired border-status-expired",   Icon: AlertOctagon },
  expiring_soon: { label: "EXPIRING SOON",  color: "text-black bg-status-expiring border-status-expiring", Icon: AlertTriangle },
  current:       { label: "CURRENT",        color: "text-white bg-status-current border-status-current",   Icon: CheckCircle2 },
  none:          { label: "NO CERTS",       color: "text-foreground bg-muted border-muted-foreground",     Icon: HelpCircle },
  unknown:       { label: "UNKNOWN",        color: "text-foreground bg-muted border-muted-foreground",     Icon: HelpCircle },
};

export default function TrafficLight({ status = "none", size = "md", testId }) {
  const cfg = MAP[status] || MAP.none;
  const { Icon } = cfg;
  const sz = size === "sm"
    ? "h-7 text-[10px] px-2 gap-1"
    : size === "lg"
    ? "h-10 text-sm px-4 gap-2"
    : "h-8 text-xs px-3 gap-1.5";
  return (
    <span
      data-testid={testId || `traffic-${status}`}
      className={`inline-flex items-center border-2 font-black uppercase tracking-wider ${cfg.color} ${sz}`}
    >
      <Icon className="w-4 h-4" strokeWidth={3} />
      {cfg.label}
    </span>
  );
}
